import { Anchor, Flex, Text } from '@mantine/core';
import { NavLink } from 'react-router';

type CandidateBreadcrumbsProps = {
  subPage: string;
};

export const CandidateBreadcrumbs = ({
  subPage,
}: CandidateBreadcrumbsProps) => (
  <Flex gap={4} wrap='nowrap'>
    <Anchor to='/candidate-list' component={NavLink} variant='gray'>
      Кандидаты
    </Anchor>
    <Text>/</Text>
    <Text c='tertiary.4' truncate='end' maw='50dvw'>
      {subPage}
    </Text>
  </Flex>
);
